import apiService from '../utils/apiService';

import {
  ADD_VEHICLE ,
   ADD_VEHICLE_START,
  ADD_VEHICLE_ERROR ,
  UPDATE_VEHICLE,
  UPDATE_VEHICLE_START,
  UPDATE_VEHICLE_ERROR,
  GET_VEHICLE,
  GET_VEHICLE_START,
  GET_VEHICLE_ERROR,
 GET_VEHICLE_LIST,
  GET_VEHICLE_LIST_START,
  GET_VEHICLE_LIST_ERROR,
  GET_VEHICLE_LIST_PAGEABLE,
  GET_VEHICLE_LIST_PAGEABLE_START,
  GET_VEHICLE_LIST_PAGEABLE_ERROR,
  DELETE_VEHICLE,
 DELETE_VEHICLE_START,
  DELETE_VEHICLE_ERROR,
  CLEAR_ERROR_VEHICLE,
} from './types';

import {
  vehicleAddPath,
  vehicleUpdatePath,
  vehicleFindByIdPath,
  vehicleFindAllPath,
  vehicleDeletePath,
  vehicleFindAllPageablePath,
} from '../constants/apiEndpoints';
import { handleServerErrorMessage, handleServerSuccessMessage } from '../utils';
import { ModalForAddOrUpdateVehicle } from '../enums/VehicleEnums';
import { ServerMessagesEnums } from '../enums/ServerMessagesEnums';

const clearError = () => {
  return {
    type: CLEAR_ERROR_VEHICLE,
  };
};

const addVehicleStart = () => {
  return {
    type: ADD_VEHICLE_START,
  };
};
const addVehicleSuccessfully = (data) => {
  return {
    type: ADD_VEHICLE,
    payload: data,
  };
};
const addVehicleUnsuccessfully = (err) => {
  return {
    type: ADD_VEHICLE_ERROR,
    payload: err,
  };
};

const updateVehicleStart = () => {
  return {
    type: UPDATE_VEHICLE_START,
  };
};
const updateVehicleSuccessfully = (data) => {
  return {
    type: UPDATE_VEHICLE,
    payload: data,
  };
};
const updateVehicleUnsuccessfully = (err) => {
  return {
    type: UPDATE_VEHICLE_ERROR,
    payload: err,
  };
};

const getVehicleStart = () => {
  return {
    type: GET_VEHICLE_START,
  };
};
const getVehicleSuccessfully = (data) => {
  return {
    type: GET_VEHICLE,
    payload: data,
  };
};
const getVehicleUnsuccessfully = (err) => {
  return {
    type: GET_VEHICLE_ERROR,
    payload: err,
  };
};

const getVehiclePageableListStart = () => {
  return {
    type: GET_VEHICLE_LIST_PAGEABLE_START,
  };
};

const getVehiclePageableListSuccessfully = (pageResponseData) => {
  return {
    type: GET_VEHICLE_LIST_PAGEABLE,
    payload: pageResponseData,
  };
};

const getVehicleListPageableUnsuccessfully = (err) => {
  return {
    type: GET_VEHICLE_LIST_PAGEABLE_ERROR,
    payload: err,
  };
};

const deleteVehicleStart = () => {
  return {
    type: DELETE_VEHICLE_START,
  };
};
const deleteVehicleSuccessfully = (id) => {
  return {
    type: DELETE_VEHICLE,
    payload: id,
  };
};
const deleteVehicleUnsuccessfully = (err) => {
  return {
    type: DELETE_VEHICLE_ERROR,
    payload: err,
  };
};

const getVehicleListStart = () => {
  return {
    type: GET_VEHICLE_LIST_START,
  };
};
const getVehicleListSuccessfully = (data) => {
  return {
    type: GET_VEHICLE_LIST,
    payload: data,
  };
};
const getVehicleListUnsuccessfully = (err) => {
  return {
    type: GET_VEHICLE_LIST_ERROR,
    payload: err,
  };
};

export const createVehicle = (vehicle, callback) => {
  return (dispatch) => {
    dispatch(addVehicleStart());
    return apiService
      .post(vehicleAddPath(), vehicle)
      .then((response) => {
        dispatch(addVehicleSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateVehicle.saveSuccessMessage,
          vehicle
        );
        callback();
      })
      .catch((err) => {
        dispatch(addVehicleUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const updateVehicle = (vehicle, callback) => {
  return (dispatch) => {
    dispatch(updateVehicleStart());
    return apiService
      .post(vehicleUpdatePath(), vehicle)
      .then((response) => {
        dispatch(updateVehicleSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateVehicle.updateSuccessMessage,
          vehicle
        );
        callback();
      })
      .catch((err) => {
        dispatch(updateVehicleUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const findAllVehiclePageble = (pageNumber, pageSize, filters) => {
  return (dispatch) => {
    dispatch(getVehiclePageableListStart());
    return apiService
      .get(vehicleFindAllPageablePath(pageNumber, pageSize, filters))
      .then((response) => {
        const pageResponseData = {
          pageNumber: response.data.number,
          emptyList: response.data.empty,
          isFirstPage: response.data.first,
          isLastPage: response.data.last,
          list: response.data.content,
          totalPages: response.data.totalPages,
          totalElements: response.data.totalElements,
        };
        dispatch(getVehiclePageableListSuccessfully(pageResponseData));
      })
      .catch((err) => {
        dispatch(getVehicleListPageableUnsuccessfully(err));
      });
  };
};

export const findVehicleById = (id) => {
  return (dispatch) => {
    dispatch(getVehicleStart());
    return apiService
      .get(vehicleByIdPath(id))
      .then((response) => {
        dispatch(getVehicleSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getVehicleUnsuccessfully(err));
      });
  };
};

export const deleteVehicle = (id) => {
  return (dispatch) => {
    dispatch(deleteVehicleStart());
    return apiService
      .delete(vehicleDeletePath(id))
      .then(() => {
        dispatch(deleteVehicleSuccessfully(id));
        handleServerSuccessMessage(
          ModalForAddOrUpdateVehicle.deleteSuccessMessage,
          { id }
        );
      })
      .catch((err) => {
        dispatch(deleteVehicleUnsuccessfully(err.response.data));
        handleServerErrorMessage(
          err?.response?.status === 404
            ? ServerMessagesEnums.deleteErrorMessage404
            : err?.response?.data
        );
      });
  };
};

export const deleteErrorVehicle = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

export const findAllVehicle = () => {
  return (dispatch) => {
    dispatch(getVehicleListStart());
    return apiService
      .get(vehicleFindAllPath())
      .then((response) => {
        dispatch(getVehicleListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getVehicleListUnsuccessfully(err));
      });
  };
};
